import React from 'react';
import { Skeleton } from './ui/skeleton';
import { Card, CardContent } from './ui/card';

/**
 * Reusable skeleton "screens" for the app's most visited pages.
 * Match layouts closely so the transition feels seamless.
 */

export const DashboardSkeleton = () => (
  <div className="min-h-screen bg-gray-50" data-testid="dashboard-skeleton">
    <div className="bg-gradient-to-r from-green-700 to-green-800 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="space-y-2">
            <Skeleton className="h-8 w-56 bg-white/20" />
            <Skeleton className="h-4 w-40 bg-white/10" />
          </div>
          <div className="flex gap-2">
            <Skeleton className="h-9 w-28 bg-white/20" />
            <Skeleton className="h-9 w-24 bg-white/10" />
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <Skeleton className="h-4 w-16 mb-2 bg-white/20" />
              <Skeleton className="h-8 w-24 bg-white/30" />
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {Array.from({ length: 3 }).map((_, i) => (
          <Card key={i}>
            <CardContent className="p-6 space-y-3">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-3 w-full" />
              <Skeleton className="h-3 w-3/4" />
              <Skeleton className="h-3 w-5/6" />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </div>
);

export const ShopGridSkeleton = ({ count = 8 }) => (
  <div
    className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
    data-testid="shop-grid-skeleton"
  >
    {Array.from({ length: count }).map((_, i) => (
      <Card key={i} className="overflow-hidden">
        <Skeleton className="w-full aspect-square rounded-none" />
        <CardContent className="p-3 space-y-2">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-1/2" />
          <Skeleton className="h-6 w-20 mt-2" />
        </CardContent>
      </Card>
    ))}
  </div>
);

export const InvestmentPlansSkeleton = () => (
  <div
    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
    data-testid="plans-skeleton"
  >
    {Array.from({ length: 3 }).map((_, i) => (
      <Card key={i} className="p-6 space-y-3">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-10 w-24" />
        <Skeleton className="h-3 w-full" />
        <Skeleton className="h-3 w-2/3" />
        <Skeleton className="h-10 w-full mt-4" />
      </Card>
    ))}
  </div>
);
